import {
    assign,
    literal,
    nullable,
    number,
    optional,
    string,
    type,
} from "superstruct";

import InstagramBaseLayoutSchema from "./InstagramBaseLayoutSettingsSchema";

const InstagramListingLayoutSettingsSchema = assign(
    type({
        label: nullable(string()),
        layout: literal("listing"),
        columns: number(),
        rows: number(),
        minColumnsCount: optional(nullable(number())),
    }),
    InstagramBaseLayoutSchema
);

export default InstagramListingLayoutSettingsSchema;
